import { Box, Flex, Text } from "@chakra-ui/layout";
import { Checkbox } from "@chakra-ui/react";
import { VotacaoPerguntaForm } from "core/features/assembleia/typings";
import { showError } from "infra/helpers/alerta";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Col, Divider, Modal, Row } from "antd";
import Button from "ui/components/Button";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import Field from "ui/components/Input/Field";
import QuestaoOpcoes from "./QuestaoOpcoes";
import QuestaoVideo from "./QuestaoVideo/index";
import QuestaoArquivo from "./QuestaoArquivo/index";

function ModalQuestao({
  open,
  value,
  onClose,
  onChange,
}: {
  open: boolean;
  value?: any;
  onChange: Function;
  onClose: Function;
}) {
  const { control, reset, handleSubmit, watch, setValue } =
    useForm<VotacaoPerguntaForm>({
      defaultValues: {
        multiplaResposta: false,
        mostrarParcial: false,
        habilitarComentario: false,
        numeroMaximoResposta: 1,
        opcoes: [],
      },
    });

  useEffect(() => {
    if (open) {
      reset({ opcoes: [], ...value });
    } else {
      reset({ opcoes: [] });
    }
  }, [value, reset, open]);

  const handleBeforeSave = useCallback(
    async (values) => {
      if (!values.titulo) {
        return showError("Informe o titulo");
      }

      if (!values.opcoes?.length) {
        return showError("Informe as opções");
      }

      onChange({ ...value, ...values });
    },
    [onChange, value]
  );

  return (
    <Modal
      width={"900px"}
      footer={
        <Flex justifyContent="flex-end" gridGap="16px">
          <Button type="button" onClick={() => onClose()}>
            CANCELAR
          </Button>
          <PrimaryButton onClick={() => handleSubmit(handleBeforeSave)()}>
            SALVAR
          </PrimaryButton>
        </Flex>
      }
      visible={open}
      onCancel={() => onClose()}
      title={
        <Text fontWeight="500" fontSize={18}>
          Questão
        </Text>
      }
    >
      <form onSubmit={(ev: any) => handleSubmit(handleBeforeSave)(ev)}>
        <Box px="8px" pb="8px" mt={-6}>
          <Row>
            <Col sm={24}>
              <Field
                label="Questão"
                rules={{
                  required: "Informe o titulo da questão",
                }}
                inputProps={{ placeholder: "Questão" }}
                control={control}
                name="titulo"
              />
            </Col>
          </Row>

          <br />

          <Row>
            <Col sm={24}>
              <Field
                label="Explicação da questão"
                control={control}
                name="descricao"
                inputProps={{
                  placeholder: "Adicione uma explicação",
                }}
              />
            </Col>
          </Row>

          <Box mt="8px" as={Row}>
            <Col sm={6}>
              <Box pt="36px">
                <Field
                  control={control}
                  name="multiplaResposta"
                  render={({ field }) => (
                    <Checkbox
                      isChecked={!!field.value}
                      onChange={() => field.onChange(!field.value)}
                    >
                      Multipla escolha?
                    </Checkbox>
                  )}
                />
              </Box>
            </Col>

            {watch("multiplaResposta") ? (
              <Col sm={8}>
                <Field
                  label="Número máximo de escolhas"
                  control={control}
                  name="numeroMaximoResposta"
                  inputProps={{
                    type: "number",
                  }}
                  rules={{ required: "Informe o número máximo de escolhas" }}
                />
              </Col>
            ) : null}
          </Box>

          <br />

          <Row>
            <Col sm={24}>
              <Field
                control={control}
                name="mostrarParcial"
                render={({ field }) => (
                  <Checkbox
                    isChecked={!!field.value}
                    onChange={() => field.onChange(!field.value)}
                  >
                    Mostrar resultado parcial?
                  </Checkbox>
                )}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col sm={24}>
              <Field
                control={control}
                name="habilitarComentario"
                render={({ field }) => (
                  <Checkbox
                    isChecked={!!field.value}
                    onChange={() => field.onChange(!field.value)}
                  >
                    Habilitar comentário?
                  </Checkbox>
                )}
              />
            </Col>
          </Row>

          <Divider />

          <Field
            render={({ field }) => <QuestaoOpcoes {...field} />}
            control={control}
            name="opcoes"
            rules={{
              required: "Informe as opções da questão",
            }}
          />

          <Divider />

          <Box>
            <Field
              render={({ field }) => (
                <QuestaoVideo
                  value={field.value}
                  onChange={(arquivos) => {
                    const arquivoVideo = arquivos?.[0];

                    field.onChange(arquivoVideo ?? null);
                    setValue("videoId", arquivoVideo?.id);
                  }}
                />
              )}
              control={control}
              name="video"
            />
          </Box>

          <Divider />

          <Box>
            <Field
              render={({ field }) => (
                <QuestaoArquivo
                  value={field.value}
                  onChange={(arquivos) => {
                    const arquivo = arquivos?.[0];

                    field.onChange(arquivo ?? null);
                    setValue("arquivoId", arquivo?.id);
                  }}
                />
              )}
              control={control}
              name="arquivo"
            />
          </Box>
        </Box>
      </form>
    </Modal>
  );
}

export default ModalQuestao;
